import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { RaysyncAPI } from './service'
import { ConnectStatus } from 'project-config/constants/raysync'
import { IRaysyncState, IRaysyncStore } from './type'
import { StoreSet, StoreGet } from 'project-config/types'
import { composeMiddleware } from 'project-config/utils'
import { getTranslateNsT } from '@/utils/get-translate-nst'
import { immer } from 'zustand/middleware/immer'
import { NotifyCenter } from 'project-config/services/notify-center'

const raysyncT = getTranslateNsT('raysync')
const commonT = getTranslateNsT('common')
const initialState = (): IRaysyncState => ({
  raysyncSoftInfo: undefined,
  showRaysyncTip: false,
  raysyncConnectStatus: ConnectStatus.CLOSED,
  raysyncModalTip: raysyncT('raysync_not_found'),
  raysyncModalTitle: commonT('common_dialog_title'),
  showRaysyncModal: false,
  downloadLink: '',
  raysyncClientVersion: '',
  raysyncNetError: false,
})

const actions = (set: StoreSet<IRaysyncStore>) => ({
  fetchRaysyncSoftInfo: async () => {
    try {
      const { data } = await RaysyncAPI.getRaysyncSoftInfo()
      set({ raysyncSoftInfo: data })
    } catch (error) {
      console.trace(error)
    }
  },
  setRaysyncConnectStatus: (value: ConnectStatus) => set({ raysyncConnectStatus: value }),
  setShowRaysyncTip: (value: boolean) => set({ showRaysyncTip: value }),
  resetRaysyncModalTip: () => {
    set(() => ({
      raysyncModalTip: raysyncT('raysync_not_found'),
      raysyncModalTitle: commonT('common_dialog_title'),
    }))
  },
  setRaysyncModalTip: (value: string) => set({ raysyncModalTip: value }),
  setShowRaysyncModal: (value: boolean) => set({ showRaysyncModal: value }),
  setRaysyncClientVersion: (value: string) => set({ raysyncClientVersion: value }),
  setRaysyncNetError: (value: boolean) => set({ raysyncNetError: value }),
})

const getters = (get: StoreGet<IRaysyncStore>) => ({
  isBreakingVersion: () => {
    const { raysyncClientVersion } = get()
    if (!raysyncClientVersion) return false
    if (raysyncClientVersion.startsWith('6.2.8.')) {
      return true
    } else {
      return false
    }
  },
})

export const useRaysyncStore = create<IRaysyncStore>()(
  composeMiddleware(
    [devtools, immer],
    (set: StoreSet<IRaysyncStore>, get: StoreGet<IRaysyncStore>) => ({
      ...initialState(),
      ...actions(set),
      ...getters(get),
    }),
  ),
)

// 同步raysync连接状态
NotifyCenter.raysyncConnectStatus.subscribe((status) => {
  const setRaysyncConnectStatus = useRaysyncStore.getState().setRaysyncConnectStatus
  setRaysyncConnectStatus(status)
})
